module.exports = __webpack_public_path__ + "img/mission.641a4501.jpeg";